import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const ShowOneServiceThunk = createAsyncThunk(
	"Services/ShowOneServiceThunk",
	async (arg, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/api/public/services/${arg}`;
			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
